import React, {useEffect, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import { WOUND_CONSTANTS } from '../../../wound/WOUND_CONSTANTS'
import axios from 'axios'
import {toast} from 'react-toastify'
import {Box, Button} from '@mui/material'
import {MoonLoader} from 'react-spinners'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import ImagePickerScroller from '../../../../reusable-components/ImagePickerScroller/ImagePickerScroller'


const WoundCareListForm = () => {
  const {id}: {id: string} = useParams()
  const [formData, setFormData] = useState({})
  const [uiElements, setUiElements] = useState([])
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [images, setImages] = useState<string[]>([])
  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const [uploadedFileKeys, setUploadedFileKeys] = useState<string[]>([])
  const [existingImageUrls, setExistingImageUrls] = useState<string[]>([])
  const [urlToFileKeyMap, setUrlToFileKeyMap] = useState<Map<string, string>>(new Map()) // Track URL to file key mapping


  const [clientId, setClientId] = useState(null)

  // Function to fetch presigned URLs for existing images
  const fetchPresignedUrl = async (fileKeys) => {
    try {
      const response = await axios.post("/batchfile/fetch-batch-urls", {
        fileKeys: fileKeys,
      })
      
      if (response.status === 200 && response.data.length > 0) {
        return response.data
      } else {
        throw new Error("No valid URL found for this file.")
      }
    } catch (err) {
      console.error("Error fetching presigned URL:", err.message)
      return null
    }
  }

  // Function to fetch all presigned URLs for existing images
  const fetchExistingImages = async (fileKeys: string[]) => {
    try {
      const presignedUrlsResponse = await fetchPresignedUrl(fileKeys)
      
      if (presignedUrlsResponse && Array.isArray(presignedUrlsResponse)) {
        // Extract URLs from the response objects
        const validUrls = presignedUrlsResponse
          .filter(item => item && item.url)
          .map(item => item.url)
        
        // Create mapping between URLs and file keys
        const urlToKeyMap = new Map()
        presignedUrlsResponse.forEach((item, index) => {
          if (item && item.url && fileKeys[index]) {
            urlToKeyMap.set(item.url, fileKeys[index])
          }
        })
        
        setExistingImageUrls(validUrls)
        setImages(validUrls) // Set initial images for ImagePickerScroller
        setUploadedFileKeys(fileKeys) // Store existing file keys
        setUrlToFileKeyMap(urlToKeyMap) // Store URL to file key mapping
      } else {
        console.error('Invalid response format from presigned URLs API')
        toast.error('Failed to load existing images - invalid response format')
      }
    } catch (error) {
      console.error('Error fetching existing images:', error)
      toast.error('Failed to load existing images')
    }
  }

useEffect(() => {
    const fetchAssessment = async () => {
      try {
        setLoading(true)
        const responseForNote = await axios.get(`/wound-assessment/${id}?isDeleted=true`)
        const {data} = responseForNote?.data
        
        setClientId(data.clientId)
        
        const clientOption = {
          label: data.clientFullName, 
          value: data.clientId
        }        
        const formData = {
          ...data,
          abpiLeg: data?.abpiLeg?.map((item) => {
            return {
              label: item,
              value: item,
            }
          }),
        }
        
        const updatedclients = [clientOption]
        
        const updatedFormData = WOUND_CONSTANTS.map((item) => {
          if (item.name === 'clientId') {
            return {
              ...item, 
              options: updatedclients,
              disabled: true  // Add disabled property
            }
          }
          return {
            ...item, 
            disabled: true  // Add disabled property to all other fields
          }
        })
        
        setFormData(formData) 
        setUiElements(updatedFormData)
        // Fetch existing images if they exist
        if (data.imageUrls && data.imageUrls.length > 0) {
          await fetchExistingImages(data.imageUrls)
        }
      } catch (error) {
        console.error('Error fetching assessment:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchAssessment()
  }, [])

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      type: 'button',
      onClick: () => history.push('/wound-care/list')
    },
  ]

  return (
    <>
      {loading ? (
        <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
          <MoonLoader color='#9db2fc' size={60} loading={loading} />
        </div>
      ) : (
        <FormWrapper
          title='Deleted Wound Care Assessment'
          content={
            <>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  margin: '0.5rem',
                  gap: '0.5rem'
                }}
              >
                <Button variant='outlined' color='primary' onClick={() => history.goBack()}>
                  Back
                </Button>
              </Box>

              {/* Display existing and new images using ImagePickerScroller */}
              <div style={{marginBottom: '20px'}}>
                <div style={{fontSize: '12px', color: '#666', marginBottom: '10px'}}>
                  Maximum 10 images, each up to 10MB. Supported formats: JPG, PNG, GIF
                </div>
                <ImagePickerScroller
                  value={images}
                  setImageUrls={() => {}} // DISABLED: Don't allow image URL changes
                  onFilesChange={() => {}} // DISABLED: Don't allow file changes
                  maxVisible={5}
                  maxFiles={10}
                  maxFileSize={10 * 1024 * 1024} // 10MB
                  disabled={true} // ADDED: Disable the image picker component
                />
              </div>

              <DynamicForm
                fields={uiElements}
                data={formData}
                onSubmit={() => {}}
                buttons={buttons}
                setFormValues={setFormData}
              />
            </>
          }
        />
      )}
    </>
  )
}

export default WoundCareListForm
